export default __webpack_public_path__ + "static/media/avatar3.ab860198.jpg";